import { useState } from 'react'
import Navbar from './../components/Navbar'
import  Footer from '../components/Footer';
import { sendResume } from '../../../api';
import axios from 'axios'

function SubmitResume() {
  const [isLoading, setIsLoading] = useState(true)
  const [file, setFile] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const initialData = {
    name: "",
    contact: "",
    email: "",
    comments:"",
    resume: null,
    isWithoutAttachment: false
  }

  const [formData, setFormData] = useState(initialData)

  const uploadFile = async (thumbnail) => {
    try {
      const formDataFinal = new FormData()
      formDataFinal.append('file', thumbnail)
      formDataFinal.append('upload_preset', 'ml_default')
      formDataFinal.append('api_key', '375547884857951')

      return axios.post('https://api.cloudinary.com/v1_1/instaclone29/image/upload',
        formDataFinal,
        { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
      )
        .then(uploadRes => uploadRes)
        .then(data => data)
        .catch(err => {
          console.log(err)
          setErrorMessage(err.message)
          return err.message
        })
    } catch (error) {
      setErrorMessage(error.message)
      setIsSubmitting(false)
    }

  }

  const isValidFile = (file) => {
    const validExtensiosn = ['.docx', '.doc', '.pdf']

    let match = file.name.match(/\.[^.]+$/g)
    if (validExtensiosn.includes(match)) {
      console.log("Matching Extension")
      return true
    }

    return false
  }

  const handleFileChange = (event) => {
    let currentFile = event.target.files[0]

    if (isValidFile(currentFile)) {
      setFile(file)
    } else {
      event.target.files = null;
      setErrorMessage("Only DOCX, DOC and PDF files are allowed")
      setFile(null)
    }
  }

  const handleSubmit = async(event)=>{
    event.preventDefault();
    setFormData(initialData)
    setIsSubmitting(true)

    let response

    try {
      response = await uploadFile(file)
    } catch (error) {
      setErrorMessage("Error uploading the file")
      setIsSubmitting(false)
      return;
    }
    // console.log("Cloudinary Response:", response)

    formData.resume = response.data.url
    formData.cloudinary_id = response.data.asset_id

    try {
      const { data } = await sendResume(formData)

      if (data.success) {
        alert("Form submitted sucessfully")
      }
      // console.log(data)
      if (data.message) {
        console.log("Running Else", data)
        setErrorMessage(data.message)
        setIsSubmitting(false)
      }

    } catch (error) {
      console.log("Error:", error)
      setErrorMessage("Error")
      setErrorMessage("Error submitting form, please check the inputs")
      setIsSubmitting(false)
    }
    // console.log("Final Data:", data)

  }

  const handleChange = (event)=>{
    const {name, value, type, checked, files} = event.target
    setFormData(prevFormData => {
      return {
        ...prevFormData,
        [name]: value
      }
    })
  }

  return (
    <>
      <Navbar/>
      <main className="container">
        <div className="formBox">
          <h2>Submit Resume</h2>
          <form className="jobResumeForm" onSubmit={handleSubmit}>
            <div className='formItem'>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name='name'
                  value={formData.name}
                  onChange={handleChange}
                  required
                  />
            </div>
            <div className="formFlex">
                <div className='formItem contact'>
                    <label htmlFor="contact">Contact Number</label>
                    <input
                      type="tel"
                      pattern="^\d{10}$"
                      name='contact'
                      value={formData.contact}
                      onChange={handleChange}
                      required
                      />
                </div>
                <div className='formItem email'>
                    <label htmlFor="email">Mail-ID</label>
                    <input
                      type="email"
                      name='email'
                      value={formData.email}
                      onChange={handleChange}
                      required
                      />
                </div>
            </div>
            <div className='formItem'>
                <label htmlFor="comments">Comments</label>
                <textarea
                  name="comment" id="" cols="30" rows="10"
                  value={formData.comment}
                  onChange={handleChange}/>
            </div>
            <div className='resumeForm'>
                <label htmlFor="resume">Attach Resume:  </label>
                <input
                  type="file"
                  name='resume'
                  accept='image/*'
                onChange={handleFileChange}
                />
            </div>
            <div className='checkbox'>
            <input
              type="checkbox"
              name="isWithoutAttachment"
              style={{display: 'inline-block'}}
              checked={formData.isWithoutAttachment}
              onChange={handleChange}
            />
            <label htmlFor="isResume" style={{fontSize: '14px'}}>Don't have you resume ready? Continue without attachment</label>
            </div>
            <button type='submit' className='submitbtn'>SUBMIT</button>
            {(errorMessage) && <div style={{color: "red"}} className="message__error">{errorMessage}</div>}
          </form>
        </div>
      </main>
      <Footer />
    </>
  )
}

export default SubmitResume
